import React, { Fragment, useState } from 'react'
import DataTable from 'react-data-table-component'
import SearchComponent from '../../_Components/SearchComponent';
import RenderProfilePicture from '../../../../../../_helpers/profile-picture';
import { Button, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import RemoveLocationModal from '../_Components/RemoveLocationModal';

export default function ListTeams({ locationTeam, handleShowAddToTeam }) {

  const [showRemoveModal, setShowRemoveModal] = useState(false)

  const columns = [
    {
      name: 'LOCATIONS',
      sort: false,
      cell: (location) => {
        return renderLocation(location)
      }
    },
    {
      name: '',
      sort: false,
      cell: (location) => {
        return <div className='w-100 d-flex justify-content-end'>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Remove</Tooltip>}
          >
            <button 
              title="Remove"
              onClick={() => setShowRemoveModal(true)}
              className="btn btn-outline-danger btn-sm mr-2">
              <i className="far fa-trash-alt"></i>
            </button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>View</Tooltip>}
          >
            <button 
              title="View"
              onClick={() => console.log('')}
              className="btn btn-outline-primary btn-sm">
              <i className="fa fa-list-alt"></i>
            </button>
          </OverlayTrigger>
        </div>
      }
    },
  ];

  const renderLocation = (location) => {
    return <div className='row w-100'>
      <div className="col-auto">
        <RenderProfilePicture height={30} width={30} image={location.profileUrl} circle cached={false} className='m-auto' />
      </div>
      <div className="col-auto">
        <div className="row">
          <div className="col">
            <div>{location.name}</div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <span className='text-muted'>{location.type}</span>
          </div>
        </div>
      </div>
    </div>
  }

  return (
    <Fragment>
      <RemoveLocationModal 
        show={showRemoveModal}
        handleClose={() => setShowRemoveModal(false)}
      />

      <div className='lead pb-3'>Location Team</div>
      <Row>
         <Col>
          <div className="axs-shadow axs-rounded p-1 mb-3" style={{background: 'white'}}>
            <DataTable
              noHeader
              columns={columns}
              data={locationTeam.data}
              subHeader
              subHeaderComponent={<SearchComponent placeholder='Search Locations'/>}
              // onChangePage={page => {
              //   const queryParams = queryString.parse(this.props.location.search);

              //   const searchParams = {
              //     firstName: queryParams.firstName || '',
              //     lastName: queryParams.lastName || ''
              //   };

              //   dispatch(userActions.setPage(page));
              //   dispatch(userActions.retrieveUsers(page, searchParams))
              // }}
              pagination={true}
              paginationServer={true}
              // paginationTotalRows={total}
              paginationRowsPerPageOptions={[15]}
              paginationPerPage={3}
              customStyles={{ 
                cells: { style: { fontSize: '14px', padding: '1.5em' }, }, 
                headCells: { style: { fontWeight: 400, color: 'RGB(161, 165, 183)', padding: '1.5em'}, }, 
                subHeader: { style: { justifyContent: 'space-between', padding: '10px 10px 0 10px' } }
              }}
            />
          </div>
         </Col>
         <Col xs='3'>
            <Button block variant='success' onClick={handleShowAddToTeam}>Add To Team</Button>
         </Col>
      </Row>
    </Fragment>
  )
}
